import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  containerStyle: {
    flex: 1,
  },
  itemContainerStyle: {
    marginBottom: 17.4,
  },
  viewGraphsContainerStyle: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    marginBottom: 16,
  },
  viewGraphsTextStyle: theme => ({
    fontSize: 16.6,
    color: theme.colors.hyperlinkFive,
  }),
});
